<template>
	<div class="bottom">
		<footer class="footer bg-style">
			<div class="footer-upper">
				<div class="container">
					<div class="sec-title text-center">
						<h2>联系我们</h2>
						<p>期待与您携手，共同并进，共创辉煌</p>
						<span class="decor"><span class="inner"></span></span>
					</div>
					<div class="row">
						<div class="col-md-3 col-sm-6">
							<div class="footer-widget about-widget">
								<a href="#">
									<img src="../../assets/img/resources/footer-logo.png"/>
								</a>
								<p class="company-cnname">{{systemInfo.company_name_cn}}</p>
								<p class="company-enname">{{systemInfo.company_name_en}}</p>
							</div>
						</div>
						<div class="col-md-4 latest-post col-sm-6 col-md-offset-1">
							<div class="footer-widget about-widget">
								<ul class="contact">
									<li><i class="fa fa-map-marker"></i> <span>{{systemInfo.company_address_cn}}</span></li>
									<li><i class="fa fa-link"></i> <span>www.bxgkzy.com</span></li>
								</ul>
							</div>
						</div>
						<div class="col-md-3 col-sm-6 col-md-offset-1">
							<div class="footer-widget about-widget">
								<ul class="contact">
									<li><i class="fa fa-phone"></i> <span>{{systemInfo.company_mobile}}</span></li>
									<li><i class="fa fa-envelope-o"></i> <span>{{systemInfo.company_email}}</span></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer-bottom">
				<div class="container text-center">
					<p>Copyright &copy; 2018 {{systemInfo.company_name_en}} All rights reserved. <a href="https://beian.miit.gov.cn/" target="_blank">{{systemInfo.icp_code}}</a></p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import Server from "@/assets/js/servers.js";
	export default {
		name: "page-footer",
		data(){
			return{
			}
		},
		created(){
			this.init(()=>{
				// console.log('load');
			});
		},
		computed:{
			...mapGetters(['systemInfo'])
		},
		methods:{
			...mapActions(['init'])
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/PageFooter.vue